import {Action, handleActions} from 'redux-actions';

import {METADATA_CATEGORIES_SET} from './CategoriesActions';
import {CategoriesState, MetadataCategoriesPayload} from '../CategoriesTypes';

export const setMetadataCategories = (state: CategoriesState, action: Action<MetadataCategoriesPayload>) => {
    const {payload} = action;
    
    if (payload) {
        return {
            data: payload,
            isLoading: false,
        };
    }
    
    return {
        ...state,
        isLoading: true,
    };
};

export const initialState = {
    data: [],
    isLoading: true,
};

const handlers = {
    [METADATA_CATEGORIES_SET]: setMetadataCategories,
};

export default handleActions(handlers, initialState);
